// import Echo from "laravel-echo";
// import Pusher from "pusher-js";

// window.Pusher = Pusher;

// const echo = new Echo({
//   broadcaster: process.env.REACT_APP_BROADCAST_DRIVER || "reverb",
//   key: process.env.REACT_APP_REVERB_APP_KEY || "gaid-key",
//   wsHost: process.env.REACT_APP_REVERB_HOST || "api.linkzdata.com",
//   wsPort: process.env.REACT_APP_REVERB_PORT || 443,
//   wssPort: process.env.REACT_APP_REVERB_PORT || 443,
//   forceTLS: process.env.REACT_APP_REVERB_SCHEME === "https",
//   enabledTransports: ["ws", "wss"],
//   authEndpoint: process.env.REACT_APP_GAID_API_BASE_URL + "/broadcasting/auth",
//   auth: {
//     headers: {
//       Authorization: `Bearer ${JSON.parse(localStorage.getItem("x-auth"))?.state?.token}`,
//     },
//   },
// });

// export default echo;

// Real-time notifications are disabled until a broadcaster is configured.
const echo = null;
export default echo;
